import React, { useState } from 'react';

import Card from './components/card';
import withPagination from '../../hoc/with-pagination';
import TrafficDetails from './traffic-details';
import { API } from '../../helpers/constants';
import LoadingListItem from './components/loading-list-item';

const Traffic = ({ data }) => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  return (
    <>
      <div className="w-full md:w-[80%] m-auto py-14">
        <div className="grid grid-cols-1 w-[80%] md:w-full md:grid-cols-2 mx-auto lg:grid-cols-3 gap-6">
          {data?.map((traffic) => (
            <Card
              isWithBorder
              title={traffic?.name}
              sourceImage={traffic?.['file_url']}
              onClick={() => {
                setSelectedId(traffic?.id);
                setIsShowModal(true);
              }}
            />
          ))}
        </div>
      </div>
      {isShowModal && (
        <TrafficDetails
          id={selectedId}
          onHide={() => {
            setSelectedId(null);
            setIsShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default withPagination(Traffic, {
  api: `${process.env.REACT_APP_API_BASE_URL}/${API.traffics}?group=2`,
  queryKey: 'traffics',
  pageNumberLimit: 8,
  header: {
    title: 'Jalur Utama & Alternatif Jawa Barat',
    subtitle: 'Cek jalur tujuan wisata atau bepergian disini.',
    button: {
      placeholder: 'Cari',
      id: 'search-traffic'
    }
  },
  loading: {
    renderItem: <LoadingListItem />,
    colItem: {
      sm: 1,
      md: 2,
      lg: 3
    }
  }
});
